<template>
    <div class="detail">
		<h2 class="title">{{list.title}}</h2>
		<span class="time color_gray"><span class="color-blue">{{list.author}}</span>&nbsp;&nbsp;&nbsp;{{list.time}}</span>
		<div class="detail-body" v-html="list.content"></div>
		<!-- <div class="position-warp" v-if="formType === '1'">
			<div class="ewm-position-warp">
				<div class="ewm-position">
					<img src="images/ewm_qb.jpg" class="ewm"/>
					<span class="color_black">扫一扫手机预览</span>
				</div>
			</div>
		</div> -->
	</div>
</template>
<script>
export default {
    data() {
        return {
            formType:'',//页面来源 1是编辑 2是我的素材
            id:'',//来源文章ID
            list:[],//文章  
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getPageData();
        })
    },
    created() {
        let formType = this.$route.query.formType;
        this.formType = formType;
        // 获取链接文章id
        let id = this.$route.query.id;
        this.id = id;
    },
    methods: {
        // 获取数据
        getPageData () {
            let that = this;
            that.$api.post('editor/preview',{type:that.formType,id:that.id},r => {
                that.$parent.returnCode(r,function(){
                   that.list = r.data[0];
                })
            })
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/detail.vue